import { Alert } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { usePrimaryOrganization } from "../../hooks";
import { Routes } from "../../root/routes";
import { LoadingButton, LoadingButtonProps } from "../../../common/components/LoadingButton";
import { DisableableButton } from "../Disableable";

export const EmailButton = (props: LoadingButtonProps & { disabledTooltip?: string }) => {
  const [org] = usePrimaryOrganization();
  const isMailboxDisconnected = !org.mailbox.canSendEmail;
  let tooltip = "You cannot send an email while your privacy email is disconnected";
  if (props.disabled && props.disabledTooltip) {
    tooltip = props.disabledTooltip;
  }

  return (
    <>
      {isMailboxDisconnected && (
        <Alert severity="error" className="mb-md">
          The email cannot be sent because your privacy email has been disconnected. Please visit
          your <Link to={Routes.privacyCenter.privacyEmails}>privacy inbox settings</Link> to
          reconnect it.
        </Alert>
      )}
      {isMailboxDisconnected && (
        <div className="d-inline-block">
          <DisableableButton
            {...props}
            disabledTooltip={tooltip}
            disabled={props.disabled || isMailboxDisconnected}
          />
        </div>
      )}
      {props.disabled && !isMailboxDisconnected && (
        <div className="d-inline-block">
          <DisableableButton {...props} disabled={props.disabled} disabledTooltip={tooltip} />
        </div>
      )}
      {!isMailboxDisconnected && !props.disabled && <LoadingButton {...props} />}
    </>
  );
};
